'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default function() {
    return {
        restrict: 'A',
        template: require('../../../../../view/table.html'),
        transclude: true,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
        },
        controller: ['$scope', '$utils', 'StatusService', 'ProjectService', 'Notification', '$security', 'ProjectTransactionService',
                     function($scope, $utils, StatusService, ProjectService, Notification, $security, ProjectTransactionService) {
                         $scope.getStatusDisplayName = StatusService.getDisplayName;
                         $scope.refresh = refresh;
                         $scope.dblClick = dblClick;
                         $scope.select = select;
                         $scope.isSelect = isSelect;
                         $scope.getItems = getItems;
                         $scope.getValue = $utils.getValue;
                         $scope.loading = true;

                         let enableDelete = false;
                         // инициализация
                         init();

                         $security.wait().then(() => {
                             // инициализация
                             init();
                             // получение данных
                             refresh();
                         });

                         // region Functions

                         function init() {
                             if (!$scope.selectedItem) {
                                 $scope.selectedItem = {};
                             }

                             if ($security.isAllowWrite('/projects/requests/rejected', 'remove')) {
                                 $scope.columns = [{
                                     name: 'Тип',
                                     data: 'operation',
                                     type: 'func',
                                     func: ProjectTransactionService.getDisplayOperator,
                                 }, {
                                     name: 'Время',
                                     type: 'datetime',
                                     data: 'createDate',
                                 }, {
                                     name: 'Код проекта',
                                     data: 'project.code',
                                 }, {
                                     name: 'Краткое наименование проекта',
                                     data: 'project.shortName',
                                 }, {
                                     name: 'Менеджер проекта',
                                     data: 'createdBy',
                                     type: 'func',
                                     func: getDisplayUser,
                                 }, {
                                     name: 'Отклонена',
                                     type: 'datetime',
                                     data: 'rejectDate',
                                 }, {
                                     name: 'Отклонил',
                                     data: 'rejectedBy',
                                     type: 'func',
                                     func: getDisplayUser,
                                 }, {
                                     name: 'Причина',
                                     data: 'comment',
                                 }];
                             } else {
                                 $scope.columns = [{
                                     name: 'Тип',
                                     data: 'operation',
                                     type: 'func',
                                     func: ProjectTransactionService.getDisplayOperator,
                                 }, {
                                     name: 'Время',
                                     type: 'datetime',
                                     data: 'createDate',
                                 }, {
                                     name: 'Код проекта',
                                     data: 'project.code',
                                 }, {
                                     name: 'Краткое наименование проекта',
                                     data: 'project.shortName',
                                 }, {
                                     name: 'Инициатор',
                                     data: 'project.author.shortName',
                                 }, {
                                     name: 'Отклонена',
                                     type: 'datetime',
                                     data: 'rejectDate',
                                 }, {
                                     name: 'Отклонил',
                                     data: 'rejectedBy',
                                     type: 'func',
                                     func: getDisplayUser,
                                 }, {
                                     name: 'Причина',
                                     data: 'comment',
                                 }];
                             }

                             $scope.searching = {
                                 isSearch: $scope.isSearch,
                                 filter: null,
                             };

                             $scope.pagination = {
                                 isPaging: $scope.isPaging,
                                 page: 1,
                                 size: $scope.isPaging ? 10 : null,
                                 totalPages: null,
                                 totalItems: null,
                             };

                             // тулбокс таблицы
                             $scope.toolbox = {
                                 // кнопки на панели управления
                                 buttons: {
                                     // редактирование
                                     edit: {
                                         show: () => isSelected(),
                                         click: (item) => ProjectService.edit(item.project, item.id),
                                         disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null,
                                     },
                                     // удаление
                                     remove: {
                                         show: () => isSelected() && enableDelete,
                                         click: (item) => ProjectService.api.deleteTransaction({transactionId: item.id}, null, (data) => $scope.refresh()),
                                         disabled: () => $scope.selectedItem == null || $scope.selectedItem.id == null || !enableDelete,
                                    },
                                     // обновление таблицы
                                     refresh: {
                                         show: () => true,
                                         click: $scope.refresh,
                                         disabled: () => false,
                                     },
                                 },
                             };
                         }

                         /**
                          * Получение всех записей
                          * @returns {*}
                          */
                         function getItems() {
                             return $scope.items;
                         }

                         /**
                          * Выбрал ли элемент!
                          * @param item проверяемый элемент
                          * @returns bool
                          */
                         function isSelect(item) {
                             return equals(getSelected(), item);
                         }

                         /**
                          * Выбрать элемент
                          * @param item выбираемый элемент
                          */
                         function select(item) {
                             if (!$scope.isSelect(item)) {
                                enableDelete = false;
                                angular.copy(item, $scope.selectedItem);
                                ProjectService.api.enableDeleteTransaction({ transactionId: item.id }, (data) => {
                                    enableDelete = data._embedded;
                                });
                             } else {
                                 angular.copy({}, $scope.selectedItem);
                             }
                         }

                         /**
                          * Двойное нажатие на запись в таблице
                          * @param item данные записи
                          */
                         function dblClick(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     $scope.toolbox.buttons.edit.click(item);
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         }

                         /**
                          * Получение фильтров
                          * @returns {Array}
                          */
                         function getFilters() {
                             let filters = [];
                             if (Array.isArray($scope.filters)) {
                                 filters = filters.concat($scope.filters);
                             }
                             filters.push(`'state' EQ 'REJECTED'`);
                             filters.push(`'project.entityStatus' EQ 'ENABLED'`);
                             return filters;
                         }

                         /**
                          * Получение поиска
                          * @returns {Array}
                          */
                         function getSearchs() {
                             let searchs = [];
                             if ($scope.isSearch) {
                                 if ($scope.searching.filter != null && !($scope.searching.filter.length < 1)) {
                                     searchs.push('\'project.shortName\':\'' + $scope.searching.filter + '\'', '\'project.name\':\'' + $scope.searching.filter + '\'');
                                 }
                             }
                             return searchs;
                         }

                         /**
                          * Выбрана ли запись
                          * @returns {boolean}
                          */
                         function isSelected() {
                             return $scope.selectedItem != null && !angular.equals($scope.selectedItem, {});
                         }

                         /**
                          * Проверка элементов на равенство
                          * @param i1
                          * @param i2
                          * @returns {*}
                          */
                         function equals(i1, i2) {
                             return angular.equals(i1, i2);
                         }

                         /**
                          * Получить выбранный элемент
                          * @returns {{}|*}
                          */
                         function getSelected() {
                             return $scope.selectedItem;
                         }

                         /**
                          * Обновить данные таблицы
                          */
                         function refresh() {
                             $scope.loading = true;
                             ProjectService.api.transactions({
                                                                 filters: getFilters(),
                                                                 searchs: getSearchs(),
                                                                 sorts: ['rejectDate:DESC', 'project.shortName:ASC', 'project.name:ASC', 'createDate:DESC'],
                                                                 page: $scope.pagination.page,
                                                                 size: $scope.pagination.size,
                                                             }, function(data) {
                                 $scope.items = data._embedded;
                                 if (isSelected()) {
                                     if ($scope.items.every((i) => i.id != getSelected().id)) {
                                         $scope.selectedItem = {};
                                     } else {
                                         angular.copy($scope.items.find((i) => i.id == getSelected().id), $scope.selectedItem);
                                     }
                                 }
                                 if ($scope.pagination.isPaging) {
                                     $scope.pagination.totalPages = data.page.totalPages;
                                     $scope.pagination.totalItems = data.page.totalElements;
                                 }
                                 $scope.loading = false;
                             });
                         }

                         function getDisplayUser(user) {
                             if (!user) return '';

                             let display = user.username;
                             if (!!user.staff && !!user.staff.shortName) {
                                 display += ' (' + user.staff.shortName + ')';
                             }
                             return display;
                         }

                         // endregion

                         // region Watchers

                         $scope.$watch('filters', function() {
                             $scope.refresh();
                         });

                         // endregion
                     }],
    };
}
